import * as React from 'react';

import { clsx } from '@freelancelabs/utils';

export interface TableProps extends React.DetailedHTMLProps<
    React.TableHTMLAttributes<HTMLTableElement>,
    HTMLTableElement
> {
    children: React.ReactNode;
    className?: string;
}

const Table = ({ children, className, ...props }: TableProps) => {
    const [mouseDown, setMouseDown] = React.useState(null);
    const childrenWithProps = React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child as React.ReactElement<any>, {
                mouseDown,
                ...(index === 0 && { setMouseDown }),
            });
        }
        return child;
    });
    return (
        <table className={clsx('fl-table', className)} {...props}>
            {childrenWithProps}
        </table>
    );
};

export default Table;
